// ** Icons Import
import { Settings } from 'react-feather'

export default [
  {
    header: 'Kordinator'
  },
  {
    id: 'manajer_projek',
    title: 'Manajer Projek',
    icon: <Settings size={20} />,
    navLink: '/forms/initial-projek'
  }
]
